export function formatLocalDateOnly(date: Date): string {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function getLocalTodayDateOnly(): string {
    return formatLocalDateOnly(new Date());
}

export function parseLocalDateOnly(dateOnly: string | null | undefined): Date | undefined {
    if (!dateOnly) {
        return undefined;
    }

    const [yearText, monthText, dayText] = dateOnly.slice(0, 10).split('-');
    const year = Number(yearText);
    const month = Number(monthText);
    const day = Number(dayText);

    if (!Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day)) {
        return undefined;
    }

    return new Date(year, month - 1, day);
}

export function normalizeApiDateOnly(dateValue: string | null | undefined): string {
    return dateValue ? dateValue.slice(0, 10) : '';
}
